import React from "react";
import './countbutton.scss';

interface CountButtonProps {
  count?: number;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
};


const CountButton: React.SFC<CountButtonProps> = (props) => {

  let className = "rpg_button";

  if(props.count && props.count > 0){
    className = "rpg_button active";
  }

  return (
    <button className={className} disabled={props.disabled} onClick={props.onClick}>{props.count}</button>
    )
}


export default CountButton;